import React from "react";
import BoxLoader from "../../../../../../components/general/boxLoader";
import EmptyBox from "../../../../../../components/general/emptyBox";
import PatientMisuseCardsBoxItem from "./patientMisuseCardsBox_Item";

type PatientMisuseCardsBoxProps = {
  dataList?: any;
  dataListTitles: string[];
  isRequesting: boolean
}

const PatientMisuseCardsBox = ({
  dataList,
  dataListTitles,
  isRequesting
}: PatientMisuseCardsBoxProps) => {
  const _dataList = dataList?.data && dataList?.data.length > 0 && dataList?.data.map((item: any, i: number) => {
    return <PatientMisuseCardsBoxItem item={item} dataListTitles={dataListTitles} key={i}/>
  })
  return (
    <div>
      {isRequesting ? <BoxLoader/> : _dataList ? _dataList : <EmptyBox content={''} className={''} children={''}/>}
    </div>
  )
}

export default PatientMisuseCardsBox;